import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  NgbModal,
  NgbModalOptions,
  NgbDatepickerConfig
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { SetPatientAction } from "../../actions";
import { AuthService, PatientService, UtilService } from "../../services";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "app-patient-details-modal",
  templateUrl: "./patient-details-modal.component.html",
  styleUrls: ["./patient-details-modal.component.scss"]
})
export class PatientDetailsEditModalComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("content") template: TemplateRef<any>;

  public years: Array<number> = [];
  public states: Array<USState>;
  public modalRef: any;
  public patient: any;
  public confirm: boolean = false;
  public editMode: boolean = true;
  public modalTitle = "Edit Patient";
  public isOfficeStaff: boolean;

  private patientId: number;
  private isAdminEdit: boolean = false;

  // exit edit/* workflow
  private cancelPath: string = "../../";

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    container: "app-patient-details-modal",
    keyboard: false
  };
  private subscriptions: { [name: string]: Subscription } = {};
  public dateOfBirth: { year: number; month: number; day: number };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private utilService: UtilService,
    private patientService: PatientService,
    private store: Store<any>,
    private authService: AuthService,
    private config: NgbDatepickerConfig
  ) {
    // customize default values of datepickers used by this component tree
    config.minDate = { year: 1900, month: 1, day: 1 };
    config.maxDate = { year: new Date().getFullYear() - 1, month: 12, day: 31 };
    // days that don't belong to current month are not visible
    config.outsideDays = "hidden";
  }

  cancel() {
    this.router.navigate([this.cancelPath], { relativeTo: this.route });
  }

  ngOnInit() {
    this.subscriptions["patient"] = this.store
      .select("patient")
      .subscribe(data => {
        this.patient = Object.assign({}, this.patient, data);
        const dob = this.patient.Dob ? this.patient.Dob.split("-") : null;
        dob !== null
          ? (this.dateOfBirth = {
              year: Number(dob[0]),
              month: Number(dob[1]),
              day: Number(dob[2])
            })
          : (this.dateOfBirth = null);
      });

    this.subscriptions[
      "params"
    ] = this.route.parent.parent.parent.params.subscribe(params => {
      this.patientId = +params["id"];
    });
    this.isOfficeStaff = this.authService.getUser().Role === "staff";

    this.subscriptions["route"] = this.route.parent.parent.data.subscribe(
      data => {
        if (data.isAdminEdit) {
          this.isAdminEdit = data.isAdminEdit;

          // admin-portal does not have a /patients/:id path, only a /patients.  let's trim off that :id
          this.cancelPath = "../../../";
        }
      }
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  setConfirm() {
    this.confirm = false;
  }

  checkFormValidity(form) {
    let detectNonAlphaRegex = /[^a-zA-Z]/g;
    return form.invalid || detectNonAlphaRegex.test(this.patient.MiddleName);
  }

  update() {
    this.patient = {
      ...this.patient,
      BirthDay: String(this.dateOfBirth.day),
      BirthMonth: String(this.dateOfBirth.month),
      BirthYear: String(this.dateOfBirth.year)
    };
    this.store.dispatch(new SetPatientAction(this.patient, this.utilService));
    this.router.navigate(["../additional-details"], { relativeTo: this.route });
  }

  isString(val) {
    return typeof val === "string";
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
    for (let sub in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(sub)) {
        this.subscriptions[sub].unsubscribe();
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/patient-details-modal/patient-details-edit-modal.component.ts